import { render, staticRenderFns } from "./LineItems.vue?vue&type=template&id=3956ff46&scoped=true"
import script from "./LineItems.vue?vue&type=script&lang=js"
export * from "./LineItems.vue?vue&type=script&lang=js"
import style0 from "./LineItems.vue?vue&type=style&index=0&id=3956ff46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956ff46",
  null
  
)

export default component.exports